import React from 'react';
import { Home } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { ROOM_TYPES } from '../../../lib/roomTypes';

export const RoomTypeSelect = ({ value, onChange, className = 'w-44', testId = 'room-type-select', allowAll = false }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={className} data-testid={testId}>
      <Home className="w-4 h-4 mr-2 text-neutral-400" />
      <SelectValue placeholder="Room scene" />
    </SelectTrigger>
    <SelectContent>
      {allowAll && (
        <SelectItem value="all" data-testid={`${testId}-option-all`}>All rooms (missing only)</SelectItem>
      )}
      {ROOM_TYPES.map((room) => (
        <SelectItem key={room.id} value={room.id} data-testid={`${testId}-option-${room.id}`}>
          {room.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default RoomTypeSelect;
